import { graphql, Link } from 'gatsby';

import { LabeledImage, SectionsWithStickyNavigation } from '@mewa/ui';

import { slugifyByLang } from '../../../../libs/slugify';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { StrapiImage } from './image';
import { ImageSlideWithNumbersData } from './image-slide';

export const StickyNavigationSlideshowFragment = graphql`
  fragment StickyNavigationSlideshowFragment on STRAPI__COMPONENT_SHARED_STICKY_NAVIGATION_SLIDESHOW {
    strapi_component
    navigationSlides {
      image {
        ...ImageSlideFragment
      }
      numbers {
        ...LabeledNumberFragment
      }
      link {
        text
        url
      }
    }
  }
`;

export const componentName = 'shared.sticky-navigation-slideshow';

export type StickyNavigationSlideshowData = {
  strapi_component: typeof componentName;
} & {
  navigationSlides: ImageSlideWithNumbersData[];
};

export const isStickyNavigationSlideshow = (
  component: PossibleContentSections,
): component is StickyNavigationSlideshowData => {
  return component.strapi_component === componentName;
};

export const StrapiStickyNavigationSlideshow = ({
  lang,
  locale,
  navigationSlides,
}: ComponentProps<StickyNavigationSlideshowData>) => {
  return (
    <SectionsWithStickyNavigation
      sections={navigationSlides.map((slide, idx) => ({
        content: (
          <LabeledImage
            key={idx}
            locale={locale}
            label={slide.image.subtitle || ''}
            number1={slide.numbers?.[0]}
            number2={slide.numbers?.[1]}
            mobileHeadlineNumber={idx + 1}
            mobileHeadlineText={slide.image.title || ''}
            image={<StrapiImage responsiveImage={slide.image} />}
            link={
              slide.link
                ? {
                    text: slide.link.text,
                    props: {
                      to: slide.link.url,
                      target: slide.link.url.startsWith('http') // check if link is external (http:// or https://)
                        ? '_blank'
                        : undefined,
                      rel: 'noreferrer',
                    },
                    component: Link,
                  }
                : undefined
            }
          />
        ),
        id: slugifyByLang(slide.image.title || '', lang),
        label: slide.image.title || '' || '',
      }))}
    />
  );
};

export const config = {
  isComponent: isStickyNavigationSlideshow,
  Component: StrapiStickyNavigationSlideshow,
  componentName,
};
